import React, {Component} from "react";
import {connect} from "react-redux";
import commaNumber from "comma-number";
import {exportMarketoForm} from "../actions";
import {LinkButton} from "../components/buttons";
import CSSSavingsGraph from "../components/css-savings-graph";
import Recommendations from "../components/recommendations";
import * as resultImages from "../components/result-page-images";

const enhance = connect(
  (state) => ({
    ...state.results,
    formWizard: state.form.wizard,
    exportMarketoForm
  }),
  (dispatch) => ({})
);



class Results extends Component {
  componentDidMount() {
    const { savings: affordabilityCalculatorAnnualsavings, formWizard: { values } } = this.props;
    const formValues = {...values, affordabilityCalculatorAnnualsavings };
    exportMarketoForm(formValues);
  }

  render() {
    const { copy: { subheading, copy, image }, recommendations, ...rest } = this.props;
    const savingsDollarValue = commaNumber(rest.savings);
    const percentage = Math.min((rest.savings / 5500) * 100, 100);
    return (
      <div id="results" className="animated fadeIn">
        <div className="columns is-centered">
          <div className="column is-half is-narrow is-10-mobile is-offset-1-mobile">
            <section className="header">
              <h1>Your students could collectively save ${savingsDollarValue} by switching textbooks</h1>
            </section>
            <div className="small-break"></div>
            <section className="box results-box">
              <section className="results-box-content">
                <section id="savings-description" className="columns is-centered">
                  <div className="column is-3 is-11-mobile has-text-centered v-centered">
                    <img src={resultImages[image]} alt={image} className="image" style={{ 'max-height': "140px" }} />
                  </div>
                  <div className="column is-8 is-11-mobile">
                    <p className="copy">
                      <strong>{subheading}</strong>
                    </p>
                    <p className="copy">{copy}</p>
                  </div>
                </section>
                <hr/>
                <section id="savings-visualization" className="columns is-gapless">
                  <div className="column is-5 v-centered">
                    <div className="savings-count is-inline-block">
                      <p className="savings-value">${rest.savings}</p>
                      <p className="savings-label">Annual Savings:</p>
                    </div>
                    <div className="arrow-right is-inline-block"></div>
                  </div>
                  <div className="column is-7 v-centered">
                    <CSSSavingsGraph width={percentage} />
                  </div>
                </section>
              </section>
              <section className="results-box-footer has-text-centered">
                <p>
                  Top Hat has already saved students hundreds of thousands of dollars on textbooks.
                  Learn more about our textbooks and why professors and students alike love them.
                </p>
                <LinkButton url="https://tophat.com/affordable-textbooks" text="Yes, I'd like to learn more" {...this.props} />
              </section>
            </section>
            <section className="recommendations">
              <Recommendations recommendations={recommendations} />
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default enhance(Results);



// WEBPACK FOOTER //
// ./src/pages/results.js